import React from "react";
import { useTheme } from "@mui/material/styles";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { Team } from "../interfaces";
import { getAppSurfaceStyles } from "../theme/siteTheme";

interface TeamMapPinProps {
  team: Team;
  lat?: number;
  lng?: number;
}

const TeamMapPin: React.FC<TeamMapPinProps> = ({ team, lat, lng }) => {
  const theme = useTheme();
  const styles = getAppSurfaceStyles(theme);
  // Defensive: Only render if lat/lng are valid finite numbers
  if (
    typeof lat !== "number" ||
    typeof lng !== "number" ||
    !isFinite(lat) ||
    !isFinite(lng)
  ) {
    return null;
  }
  return (
    <Box
      sx={{
        position: "absolute",
        transform: "translate(-50%, -100%)",
      }}
      onClick={() => {
        if (team.spielort && team.spielort.link) {
          window.open(team.spielort.link, "_blank");
        }
      }}
    >
      <Typography
        sx={styles.pinLabel}
      >
        {team.spielort?.name || team.name}
      </Typography>
    </Box>
  );
};

export default TeamMapPin;
